import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    copyUrl: string;
    viewInProject: string;
    viewInTrash: string;
    download: string;
    import: string;
    imageLabel: ({ name }: {
        name: string;
    }) => string;
    restricted: string;
    itemCountLabel: ({ count }: {
        count: number;
    }) => string;
    versionPrefixLabel: string;
    formattedDate: (displayDate: Date) => string;
    commentCountLabel: ({ count }: {
        count: number;
    }) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Button label to copy asset URL */
            copyUrl: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AssetItemDetailQS.copyUrl?c=dubbsl04cxng", defaultMessage: "Copy URL" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to view asset in its project */
            viewInProject: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AssetItemDetailQS.viewInProject?c=2le9k4ftq4ndt", defaultMessage: "View in Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to view asset in trash/recently deleted */
            viewInTrash: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AssetItemDetailQS.viewInTrash?c=1cogtekybqtzx", defaultMessage: "Go to Recently Deleted" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to download asset */
            download: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AssetItemDetailQS.download?c=82r1papihj9v", defaultMessage: "Download" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to import asset (used in Premiere client) */
            import: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AssetItemDetailQS.import?c=1738ymkzqvsth", defaultMessage: "Import" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessibility label for viewing asset in player */
            imageLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ name }: {
                        name: string;
                    }): string => __intl__.intl().formatMessage({ id: "AssetItemDetailQS.imageLabel?c=8lxe12d1cpb9", defaultMessage: "View {name} in player" }, { name: name }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for restricted folder access */
            restricted: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AssetItemDetailQS.restricted?c=1uwijwqg1t0rx", defaultMessage: "Restricted" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Folder item count display with pluralization */
            itemCountLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ count }: {
                        count: number;
                    }): string => __intl__.intl().formatMessage({ id: "AssetItemDetailQS.itemCountLabel?c=2kb4pieitnsjm", defaultMessage: "{count, plural, one {1 item} other {{count} items}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Prefix label for version number (e.g., "V1") */
            versionPrefixLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AssetItemDetailQS.versionPrefixLabel?c=1wivil9uz1glq", defaultMessage: "V" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Formatted display date for asset (e.g., "Jan 26, 2026") */
            formattedDate: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (displayDate: Date): string => __intl__.intl().formatMessage({ id: "AssetItemDetailQS.formattedDate?c=3k644jhwhoy6v", defaultMessage: "{displayDate, date, medium}" }, { displayDate: displayDate }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessible label for the comment count indicator (e.g. "5 comments"). */
            commentCountLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ count }: {
                        count: number;
                    }): string => __intl__.intl().formatMessage({ id: "AssetItemDetailQS.commentCountLabel?c=9w6ib6tjh6dc", defaultMessage: "{count, plural, one {1 comment} other {{count} comments}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
